(() => {
  const ROOT_ATTR = 'data-fio';
  const MOTION_ATTR = 'data-fio-motion';
  const STATIC_ATTR = 'data-fio-static';
  const RETRY_MS = 80;
  const RETRY_MAX = 40;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showStatic = (root) => {
    if (root) root.setAttribute(STATIC_ATTR, '');
  };

  const destroyMotion = (root) => {
    if (!root) return;
    if (root._fioRetry) {
      window.clearTimeout(root._fioRetry);
      root._fioRetry = null;
    }
    if (root._fioCtx) {
      root._fioCtx.revert();
      root._fioCtx = null;
    }
    root.removeAttribute(MOTION_ATTR);
    root.removeAttribute(STATIC_ATTR);
  };

  const setupMotion = (root, attempt) => {
    if (!root || root.hasAttribute(MOTION_ATTR)) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if ((attempt || 0) < RETRY_MAX) {
        root._fioRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
      showStatic(root);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    root.setAttribute(MOTION_ATTR, '');

    if (prefersReducedMotion()) {
      showStatic(root);
      return;
    }

    const heading = root.querySelector('[data-fio-heading]');
    const cards = root.querySelectorAll('[data-fio-card]');
    if (!heading && !cards.length) return;

    root._fioCtx = gsap.context(() => {
      if (heading) gsap.set(heading, { autoAlpha: 0, y: 12 });
      cards.forEach((card, index) => {
        gsap.set(card, { autoAlpha: 0, x: index % 2 === 0 ? -12 : 12 });
      });

      const parts = [];
      if (heading) parts.push(heading);
      cards.forEach((card) => parts.push(card));

      gsap.to(parts, {
        autoAlpha: 1,
        x: 0,
        y: 0,
        duration: 0.4,
        stagger: 0.04,
        ease: 'power1.out',
        clearProps: 'transform',
        scrollTrigger: {
          trigger: root,
          start: 'top 90%',
          once: true
        }
      });
    }, root);
  };

  const scan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => setupMotion(root, 0));
  };

  const rescan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach(destroyMotion);
    scan();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(`[${ROOT_ATTR}]`);
    if (root) destroyMotion(root);
  });
})();
